import { render } from "./TableTip.vue?vue&type=template&id=c1f2d9ee"
import script from "./TableTip.vue?vue&type=script&lang=js"
export * from "./TableTip.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__